import { restRequest } from './RequestHelper';

/**
 * set decimal amount with .00 in dashboard
 *
 */
export function setDashboardAmount(amount) {
  return parseFloat(amount) > 0 ? parseFloat(amount).toFixed(2) : amount;
}
